import BaseEntity from '../base/BaseEntity.model';

export default class Nomina extends BaseEntity {
    public tarjetaId?: number;
    public subsidioId?: number;
    public monto?: string;
    public month?: number;
    public year?: number;
    public fechaTransaccion?: Date;
    public subsidioAbr?: string;
    public subsidioNombre?: string;
    public subsidioCodigo?: string;
    public numeroTarjeta?: string;
    public bancoNombre?: string;
    constructor() {
        super();
        this.init();
    }

    init() {
        this.id = undefined;
        this.monto = undefined;
        this.fechaTransaccion = undefined;
    }
}

